export enum OpenResponseLengthIdentifier {
	Short = 0,
	Medium,
	Long
}
